
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22 22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.5 7.43h19M6 1.065v1.818m10-1.818v1.818M1.5 21.066h19c.276 0 .5-.204.5-.455V3.34c0-.252-.224-.455-.5-.455h-19c-.276 0-.5.203-.5.455V20.61c0 .251.224.455.5.455z","fill":"none"}})])
          )
        }
      }
    